export default __webpack_public_path__ + "static/media/hamburger.1bfd77e2.svg";